<template>
  <div id="app">
    <router-view></router-view>
    <ErrorModal />
  </div>
</template>

<script>
  import ErrorModal from "@/components/modal/ErrorModal.vue";

  export default {
    name: "App",
    components: {
      ErrorModal,
    },
  };
</script>

<style>
  @import url("@/assets/global.css");
  #app {
    font-family: "Sul sans" !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }
</style>
